import { render } from "./LikeButtonComp.vue?vue&type=template&id=98e10a40&scoped=true&ts=true"
import script from "./LikeButtonComp.vue?vue&type=script&lang=ts"
export * from "./LikeButtonComp.vue?vue&type=script&lang=ts"

import "./LikeButtonComp.vue?vue&type=style&index=0&id=98e10a40&lang=scss"
import "./LikeButtonComp.vue?vue&type=style&index=1&id=98e10a40&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98e10a40"]])

export default __exports__